import { Routes } from '@angular/router';
import { MeetingListComponent } from './pages/meeting-list/meeting-list';
import { MeetingNewComponent } from './pages/meeting-new/meeting-new';
import { MeetingRoomComponent } from './pages/meeting-room/meeting-room';

export const routes: Routes = [
  { path: '', redirectTo: 'meetings', pathMatch: 'full' },
  { path: 'meetings', component: MeetingListComponent },
  { path: 'new', component: MeetingNewComponent },
  { path: 'meeting/:id', component: MeetingRoomComponent },
  { path: '**', redirectTo: 'meetings' },
];
